module.exports = __webpack_public_path__ + "static/media/aws_rds_mysql.7585d2a5.svg";